'use strict';
import Customer from './customer';
import RegistrationHelper from './registrationHelper';
import { newModalFromString } from '../components/modal';

const SELECTORS = {
    btnEmailNext: '.js-btn-email-next',
    btnLoginSubmit: '.js-btn-login-submit',
    closeLoginPopup: '.js-close-login-popup, .tingle-modal',
    layerLoginTrigger: '.js-layer-login',
    emailInput: '#unified-email',
    emailError: '.js-email-error',
    emailFormGroup: '.js-email-form-group',
    emailRecap: '.js-email-recap',
    emailRecapValue: '.js-email-recap-value',
    passwordInput: '#login-form-password',
    passwordError: '.js-login-error',
    loginFormError: '#unified-login-form .login-form-error',
    loginForm: '#unified-login-form',
    passwordWrapper: '.js-password-wrapper',
    rememberMeWrapper: '.js-remember-me-wrapper',
    resetPasswordWrapper: '.js-reset-password-wrapper',
    loginDescription: '.js-login-description',
    loginSubtitle: '.js-login-subtitle',
    socialSection: '.js-unified-social-section',
    phoneInput: '#unified-phone',
    phonePrefix: '#unified-phone-prefix',
    phoneNextBtn: '.js-btn-phone-next',
    phoneStepEmailRecap: '.js-phone-step-email',
    phoneCsrfToken: '#unified-phone-csrf-token',
    phoneError: '#reg-phone-error',
    stepEmail: '.js-step-email',
    stepPhone: '.js-step-phone',
    stepRegister: '.js-step-register',
    allSteps: '.js-unified-step',
    checkEmailUrlHolder: '#checkEmailURL',
    phoneCheckUrlHolder: '#phoneCheckURL',
    btnStepBack: '.js-unified-step-back',
    regEmailRecap: '.js-register-step-email',
    regPhoneRecap: '.js-register-step-phone',
    regFirstName: '#registration-form-fname',
    regLastName: '#registration-form-lname',
    regDob: '#dpReg',
    regGender: '#registration-form-gender',
    dobDay: '#dob-day',
    dobMonth: '#dob-month',
    dobYear: '#dob-year',
    dobWrapper: '.js-dob-wrapper',
    dobError: '.js-dob-error',
    registerForm: '.registration-step-final',
    herokuWarning: '.js-phone-heroku-warning',
    stepOtp: '.js-step-otp',
    otpInput: '.otp-code-input-field',
    otpConfirmBtn: '.js-register-otp',
    wrongOtpError: '.wrong-opt-inserted',
    expiredOtpError: '.expired-opt-inserted',
    pageWrapper: '.js-unified-page-wrapper',
    unifiedLoyaltyRegistration: '.js-proceed-to-unified-loyalty-registration',
    alreadyRegisteredUserSubmitLoyaltyRegistration: '.js-unified-loyalty-registration-container form.registration-loyalty'
};

class RegistrationApi {
    constructor () {
        this.currentRequest = null;
    }

    checkEmail (emailAddress, url) {
        if (this.currentRequest) {
            this.currentRequest.abort();
        }
        this.currentRequest = $.ajax({
            url: url,
            type: 'GET',
            data: { emailAddress: emailAddress }
        });
        return this.currentRequest;
    }

    checkPhone (data, url) {
        if (this.currentRequest) {
            this.currentRequest.abort();
        }
        this.currentRequest = $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            data: data
        });
        return this.currentRequest;
    }
}

const GENDER_MAP = {
    'M': '1',
    'F': '2',
    'X': '3',
    'U': '4'
};

/**
 * Maps the gender value (M/F or others) to its numeric representation
 * @param {string|number} gender - Gender value
 * @returns {string} Mapped gender value
 */
function mapGender (gender) {
    if (!gender) return '';
    var genderStr = String(gender).toUpperCase();
    return GENDER_MAP[genderStr] || genderStr;
}

class UnifiedRegistration {
    constructor () {
        this.api = new RegistrationApi();
        this.isSubmitting = false;
        // Once an auto-submitted OTP comes back wrong/expired, we stop
        // auto-submitting and require an explicit click via the (now shown) button.
        this.otpManualMode = false;
        this.isSocialResetState = false;
        this.isSocialRegistrationFlow = false;
        this.isLoyaltyModalOpening = false;
        this.socialName = '';
    }

    // The standalone full-page flow (newLogin.isml) wraps its copy of these same steps in
    // .js-unified-page-wrapper; the modal has no such wrapper. Its absence is therefore a
    // reliable signal that we're running inside the modal instead.
    isModal () {
        return $(SELECTORS.pageWrapper).length === 0;
    }

    // ─── Analytics (NEW REG FLOW) ────────────────────────────────────────────

    getRegFlowPosition () {
        return this.isModal() ? 'modal' : 'landing_page';
    }

    /**
     * - country without loyalty: "only_registration"
     * - loyalty country excluded from implicit loyalty: depends on the loyalty flag
     * - loyalty country with implicit loyalty: always "profile_loyalty"
     * @returns {string} type of account
     */
    getTypeOfAccount () {
        if ($('#hasCurrentCountryLoyalty').val() !== 'true') {
            return 'only_registration';
        }
        if ($('#isCountryExcludedFromImplicitLoyalty').val() === 'true') {
            return $(SELECTORS.stepRegister).find('.loyalty-flag, .loyaltyFlag').first().is(':checked') ? 'profile_loyalty' : 'only_registration';
        }
        return 'profile_loyalty';
    }

    /**
     * Triggers a registration step analytics event, including client-side validation errors (no AJAX call).
     * @param {string} eventName - customer:registerFirst / customer:registerSecond / customer:registerThird
     * @param {boolean} isError - step result
     * @param {Object} [extraData] - additional trigger data
     */
    trackRegistrationStep (eventName, isError, extraData) {
        var isSocial = $('#isSocialRegistration').val() === 'true';
        $('body').trigger(eventName, $.extend({
            'type': 'registration',
            'status': isError ? 'error' : 'success',
            'regFlowPosition': this.getRegFlowPosition(),
            'isSocial': isSocial,
            'socialName': isSocial ? (this.socialName || '') : '',
            'data': {
                'error': !!isError
            }
        }, extraData));
    }

    trackConfirmOptin (isError) {
        $('body').trigger('analytics:registerConfirmOptin', {
            'error': !!isError,
            'typeOfAccount': this.getTypeOfAccount(),
            'regFlowPosition': this.getRegFlowPosition()
        });
    }

    init () {
        var _self = this;
        var ns = '.unifiedRegistration';

        if ($(SELECTORS.pageWrapper).length) {
            $('.js-unified-login-popup, #login-popup').remove();
        }

        this.unifiedModalLoyaltyRegistrationInit();

        var $emailNextBtn = $(SELECTORS.btnEmailNext);
        if ($emailNextBtn.length && !$emailNextBtn.data('original-label')) {
            $emailNextBtn.data('original-label', $emailNextBtn.text().trim());
        }

        var loginFormEl = document.getElementById('unified-login-form');
        if (loginFormEl) {
            loginFormEl.addEventListener('submit', function (e) {
                var $emailNextBtn = $(SELECTORS.btnEmailNext);
                if ($emailNextBtn.length && $emailNextBtn.is(':visible') && !$emailNextBtn.hasClass('hidden')) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    _self.handleEmailNext(e);
                }
            }, true);
        }

        $('body').off(ns)
            .on('click' + ns, SELECTORS.btnEmailNext, function (e) {
                _self.handleEmailNext(e);
            })
            .on('click' + ns, SELECTORS.btnStepBack + ', .ico-back-registration', function (e) {
                e.preventDefault();
                _self.handleStepBack(e);
            })
            .on('click' + ns, SELECTORS.phoneNextBtn, function (e) {
                _self.handlePhoneNext(e);
            })
            .on('submit' + ns, 'form[name="unified-phone-form"]', function (e) {
                e.preventDefault();
                _self.handlePhoneNext(e);
            })
            .on('unifiedRegistration:socialRegistration' + ns, function (e, data) {
                _self.handleSocialRegistrationTransition(data);
            })
            .on('input change' + ns, SELECTORS.emailInput, function () {
                if (_self.isSocialResetState) {
                    _self.isSocialResetState = false;
                    var originalLabel = $(SELECTORS.btnEmailNext).data('original-label');
                    $(SELECTORS.btnEmailNext).text(originalLabel);
                }
                $(SELECTORS.emailInput).removeClass('parsley-error is-invalid');
                $(SELECTORS.emailError).text('').hide();
            })
            .on('input' + ns, SELECTORS.phoneInput, function () {
                _self.handlePhoneInputChange();
            })
            .on('input change' + ns, '#registration-form-fname, #registration-form-lname, #registration-form-password, #registration-form-password-confirm', function () {
                _self.updateButtonStatus();
            })
            .on('click' + ns, SELECTORS.registerForm + ' button[type="submit"]', function () {
                _self.handleRegisterSubmitClick(this);
            })
            .on('submit' + ns, SELECTORS.registerForm, function (e) {
                e.preventDefault();
                _self.handleRegisterSubmit(e);
            })
            .on('keyup input' + ns, SELECTORS.otpInput, function (e) {
                _self.handleOtpKeyup(e, this);
            })
            .on('paste' + ns, SELECTORS.otpInput, function (e) {
                _self.handleOtpPaste(e, this);
            })
            .on('click' + ns, SELECTORS.otpConfirmBtn, function (e) {
                _self.handleOtpConfirm(e);
            })
            .on('login:error' + ns, SELECTORS.loginForm, function (e, data) {
                _self.handleLoginError(data);
            })
            .on('click' + ns, SELECTORS.unifiedLoyaltyRegistration, function (e) {
                _self.proceedToUnifiedRegistrationLoyaltyInit(e);
            })
            .on('submit' + ns, SELECTORS.alreadyRegisteredUserSubmitLoyaltyRegistration, function (e) {
                _self.handleLoyaltyRegisterSubmit(e);
            })
            .on('click' + ns, '.js-unified-account-delete-button', function (e) {
                _self.handleUnifiedAccountDelete(e);
            })
            // Synchronize visual privacy toggles with hidden legacy radio buttons
            .on('change' + ns, '.js-add-to-email-toggle', function () {
                var isChecked = $(this).is(':checked');
                var $yesRadio = $('#add-to-email-list-yes');
                var $noRadio = $('#add-to-email-list-no');
                var $personalizedToggle = $('.js-add-to-personalized-toggle');
                var $profilingText = $('.js-profiling-text');

                if (isChecked) {
                    $yesRadio.prop('checked', true).trigger('change');
                    $noRadio.prop('checked', false).trigger('change');
                    $personalizedToggle.prop('disabled', false);
                    $profilingText.removeClass('disabled').find('.disable-link-privacy').removeClass('disabled');
                } else {
                    $noRadio.prop('checked', true).trigger('change');
                    $yesRadio.prop('checked', false).trigger('change');
                    $personalizedToggle.prop('checked', false).prop('disabled', true).trigger('change');
                    $profilingText.addClass('disabled').find('.disable-link-privacy').addClass('disabled');
                }
            })
            .on('change' + ns, '.js-add-to-personalized-toggle', function () {
                var isChecked = $(this).is(':checked');
                var $yesRadio = $('#add-to-personalized-news-list-yes');
                var $noRadio = $('#add-to-personalized-news-list-no');

                if (isChecked) {
                    $yesRadio.prop('checked', true).trigger('change');
                    $noRadio.prop('checked', false).trigger('change');
                } else {
                    $noRadio.prop('checked', true).trigger('change');
                    $yesRadio.prop('checked', false).trigger('change');
                }
            });

        // Initialize Customer Service registration flow if the flag is active on page load
        if ($('#scFlowActive').length && $('#scFlowActive').val() === 'true') {
            this.initCustomerServiceFlow();
        }

        // Initialize Order Confirmation registration flow if the flag is active on page load
        if ($('#orderConfirmationFlowActive').length && $('#orderConfirmationFlowActive').val() === 'true') {
            this.initOrderConfirmationFlow();
        }
    }

    // ─── Login error ─────────────────────────────────────────────────────────

    // FormHelpers.init (triggered by header.js before this fires) already wrote the
    // generic server message into .login-form-error; here we swap it for the
    // translatable Figma copy, unless the server flagged something more actionable
    // (e.g. disabled account with a resend-activation link) that the user still needs to see.
    handleLoginError (data) {
        if (data && data.alreadyRegistered) return;

        var $errorBox = $(SELECTORS.loginFormError);
        var customMsg = $errorBox.data('invalid-message');
        if (customMsg) {
            $errorBox.html(customMsg).removeClass('hidden');
        }
    }

    // ─── Step 1: Email ───────────────────────────────────────────────────────

    handleEmailNext (e) {
        e.preventDefault();
        if (this.isSubmitting) return;

        var $emailInput = $(SELECTORS.emailInput);
        var $emailError = $(SELECTORS.emailError);

        if (!this.validateEmail($emailInput)) {
            if (!this.isSocialResetState) {
                this.trackRegistrationStep('customer:registerFirst', true);
            }
            return;
        }

        var emailVal = $emailInput.val().trim();

        if (this.isSocialResetState) {
            this.handleSocialResetPassword(emailVal, $emailInput, $emailError);
            return;
        }

        var url = $(SELECTORS.checkEmailUrlHolder).data('url');
        if (!url) {
            console.error('Unified Registration: Missing #checkEmailURL in DOM.');
            return;
        }

        this.checkEmailAjax(emailVal, url, $emailInput, $emailError);
    }

    handleSocialRegistrationTransition (data) {
        $('#isSocialRegistration').val('true');
        // Gigya provider, used by the social registration analytics
        this.socialName = data.socialName || '';
        var $emailInput = $(SELECTORS.emailInput);
        var emailVal = data && data.socialMail ? data.socialMail : '';
        if ($emailInput.length && emailVal) {
            $emailInput.val(emailVal).attr('readonly', 'readonly');
            this.toggleVisible(SELECTORS.emailFormGroup, false);
            $(SELECTORS.emailRecapValue).text(emailVal);
            this.toggleVisible(SELECTORS.emailRecap, true);
        }

        if (data && data.socialRegistrationFields) {
            var fields = data.socialRegistrationFields;
            if (fields.prefix) {
                this.setPhonePrefix(fields.prefix);
            }
            if (fields.phoneWithoutPrefix) {
                $(SELECTORS.phoneInput).val(fields.phoneWithoutPrefix);
            }
        }

        if (emailVal) {
            var _self = this;
            var url = $(SELECTORS.checkEmailUrlHolder).data('url');
            if (url) {
                $.spinner().start();
                this.api.checkEmail(emailVal, url)
                    .done(function (emailData) {
                        $.spinner().stop();
                        var placeholder = emailData && emailData.hiddenPhonePlaceholder ? emailData.hiddenPhonePlaceholder : '';
                        var warnMsg = emailData && emailData.warnMsg ? emailData.warnMsg : '';
                        _self.transitionToPhone(placeholder, warnMsg);
                    })
                    .fail(function () {
                        $.spinner().stop();
                        _self.transitionToPhone();
                    });
                return;
            }
        }

        this.transitionToPhone();
    }

    handleSocialResetPassword (emailVal, $emailInput, $errorEl) {
        var _self = this;
        this.isSubmitting = true;
        $.spinner().start();

        var actionUrl = $('.reset-password-form').attr('action');

        $.ajax({
            url: actionUrl,
            type: 'POST',
            dataType: 'json',
            data: {
                loginEmail: emailVal,
                csrf_token: $('input[name="csrf_token"]').val()
            }
        }).done(function (data) {
            $.spinner().stop();
            if (!data.success) {
                var errMsg = data.error || (data.fields && data.fields.loginEmail) || 'Error';
                _self.showValidationError($emailInput, $errorEl, errMsg);
                return;
            }

            var successMsg = data.receivedMsgBody;
            $('.js-email-form-group').addClass('hidden');
            $(SELECTORS.btnEmailNext).addClass('hidden');
            $(SELECTORS.socialSection).addClass('hidden');
            
            $('.js-social-reset-success-text').text(successMsg);
            _self.toggleVisible('.js-social-reset-success-message', true);
            
        }).fail(function () {
            $.spinner().stop();
            var errMsg = $emailInput.data('error-generic');
            _self.showValidationError($emailInput, $errorEl, errMsg);
        }).always(function () {
            _self.isSubmitting = false;
        });
    }

    validateEmail ($emailInput) {
        var parsleyField = $emailInput.parsley();
        parsleyField.validate();
        return parsleyField.isValid();
    }

    checkEmailAjax (emailVal, url, $emailInput, $emailError) {
        var _self = this;
        this.isSubmitting = true;
        $.spinner().start();

        this.api.checkEmail(emailVal, url)
            .done(function (data) {
                $.spinner().stop();

                if (!data.success) {
                    var msg = data.message || $emailInput.data('parsley-type-message') || '';
                    _self.showValidationError($emailInput, $emailError, msg);

                    // Analytics tracking Step 1 Error
                    _self.trackRegistrationStep('customer:registerFirst', true);
                    return;
                }

                if (data.exists) {
                    if (data.isSocial) {
                        _self.showValidationError($emailInput, $emailError, data.socialErrorMsg);
                        _self.isSocialResetState = true;
                        $(SELECTORS.btnEmailNext).text(data.socialResetBtnLabel);

                        // Analytics tracking Step 1 Error
                        _self.trackRegistrationStep('customer:registerFirst', true);
                        return;
                    }
                    _self.transitionToLogin(emailVal);
                    return;
                }

                // Analytics tracking Step 1 Success
                _self.trackRegistrationStep('customer:registerFirst', false);

                _self.transitionToPhone(data.hiddenPhonePlaceholder);
            })
            .fail(function (jqXHR) {
                $.spinner().stop();
                if (jqXHR.statusText === 'abort') return;
                var msg = $emailInput.data('error-generic') || '';
                _self.showValidationError($emailInput, $emailError, msg);

                // Analytics tracking Step 1 Error
                _self.trackRegistrationStep('customer:registerFirst', true);
            })
            .always(function () {
                _self.isSubmitting = false;
            });
    }

    // ─── Login state (existing user) ─────────────────────────────────────────

    transitionToLogin (emailVal) {
        var $emailInput = $(SELECTORS.emailInput);
        if (emailVal) $emailInput.val(emailVal);
        $emailInput.attr('readonly', 'readonly');

        // Swap the editable email field for a plain-text recap (standalone markup/CSS,
        // avoids fighting the site-wide .form-control-label cascade for a read-only display)
        $(SELECTORS.emailRecapValue).text($emailInput.val().trim());
        this.toggleVisible(SELECTORS.emailFormGroup, false);
        this.toggleVisible(SELECTORS.emailRecap, true);

        // Update No Loyalty titles dynamically to show "Accedi"
        var $titleNoLoy = $('.cc-unified-logo-title-noloy, .cc-unified-description-title-noloy');
        $titleNoLoy.each(function () {
            var loginTitle = $(this).data('title-login-noloy');
            if (loginTitle) {
                $(this).text(loginTitle);
            }
        });

        this.toggleVisible(SELECTORS.loginDescription, true);
        this.toggleVisible(SELECTORS.loginSubtitle, true);
        this.toggleVisible(SELECTORS.passwordWrapper, true);
        this.toggleVisible(SELECTORS.resetPasswordWrapper, true);
        this.toggleVisible(SELECTORS.rememberMeWrapper, true);
        this.toggleVisible(SELECTORS.btnLoginSubmit, true);
        this.toggleVisible(SELECTORS.btnEmailNext, false);
        this.toggleVisible(SELECTORS.socialSection, true);
        this.toggleVisible(SELECTORS.btnStepBack, true);
        $(SELECTORS.passwordInput).focus();
    }

    // ─── Step 2: Phone ───────────────────────────────────────────────────────

    transitionToPhone (hiddenPhonePlaceholder, warnMsg) {
        if (this.isModal()) {
            var $logoTitle = $('.cc-unified-logo-title-noloy');
            var registerTitle = $logoTitle.data('title-register-noloy');
            if (registerTitle) {
                $logoTitle.text(registerTitle);
            }
        }

        $(SELECTORS.phoneStepEmailRecap).text($(SELECTORS.emailInput).val().trim());
        this.toggleVisible(SELECTORS.stepEmail, false);
        this.toggleVisible(SELECTORS.stepPhone, true);
        this.toggleVisible(SELECTORS.btnStepBack, true);

        if (!this.isModal()) {
            $('body').addClass('cc-registration-funnel-active');
        }

        var $phoneInput = $(SELECTORS.phoneInput);
        if (!$phoneInput.length) return;

        if (hiddenPhonePlaceholder) {
            $phoneInput.attr('placeholder', hiddenPhonePlaceholder);
            $phoneInput.closest('.js-registrationModal__phoneField').addClass('always-float');
            $phoneInput.data('exists-on-heroku', true);
            if (warnMsg) {
                $(SELECTORS.herokuWarning).text(warnMsg);
            }
            this.toggleVisible(SELECTORS.herokuWarning, true);

            $phoneInput.focus();
            return;
        }

        $phoneInput.attr('placeholder', '');
        $phoneInput.closest('.js-registrationModal__phoneField').removeClass('always-float');
        $phoneInput.data('exists-on-heroku', false);
        this.toggleVisible(SELECTORS.herokuWarning, false);
        $phoneInput.focus();
    }

    handlePhoneInputChange () {
        var isFilled = $(SELECTORS.phoneInput).val().trim() !== '';
        $(SELECTORS.phoneNextBtn).prop('disabled', !isFilled);
        $(SELECTORS.phoneInput).removeClass('parsley-error is-invalid');
        $(SELECTORS.phoneError).empty().addClass('hidden');
    }

    handlePhoneNext (e) {
        e.preventDefault();
        if (this.isSubmitting) return;

        var $confirmBtn = $(e.currentTarget);
        var $container = $confirmBtn.closest(SELECTORS.stepPhone);
        var $prefixInput = $container.find(SELECTORS.phonePrefix);
        var $phoneInput = $container.find(SELECTORS.phoneInput);

        $prefixInput.parsley().validate();
        $phoneInput.parsley().validate();
        if (!$prefixInput.parsley().isValid() || !$phoneInput.parsley().isValid()) {
            this.trackRegistrationStep('customer:registerSecond', true);
            return;
        }

        var url = $(SELECTORS.phoneCheckUrlHolder).data('url');
        if (!url) {
            console.error('Unified Registration: Missing #phoneCheckURL in DOM.');
            return;
        }

        var $csrfInput = $container.find(SELECTORS.phoneCsrfToken);
        var postData = {
            dwfrm_profile_customer_prefix: $prefixInput.val().trim(),
            dwfrm_profile_customer_phone: $phoneInput.val().trim(),
            loginEmail: $container.find(SELECTORS.phoneStepEmailRecap).text().trim(),
            isModalFlow: this.isModal()
        };
        postData[$csrfInput.attr('name')] = $csrfInput.val();

        $(SELECTORS.phoneError).empty().removeClass('login-form-error-block').addClass('success-block hidden');

        var _self = this;
        this.isSubmitting = true;
        $.spinner().start();

        this.api.checkPhone(postData, url)
            .done(function (data) {
                $.spinner().stop();
                if (data.success) {
                    // Analytics tracking Step 2 Success
                    _self.trackRegistrationStep('customer:registerSecond', false);

                    _self.transitionToRegister(data.existsInHeroku ? data.customerData : null, data.hideDob);
                } else {
                    var errMsg = data.error
                        ? (Array.isArray(data.error) ? data.error.join('<br/>') : data.error)
                        : (data.message || '');

                    // Analytics tracking Step 2 Error
                    _self.trackRegistrationStep('customer:registerSecond', true);

                    _self.showPhoneError(errMsg);
                    $phoneInput.addClass('parsley-error is-invalid');
                    $(SELECTORS.phoneNextBtn).prop('disabled', true);
                }
            })
            .fail(function (jqXHR) {
                $.spinner().stop();
                if (jqXHR.statusText !== 'abort') {
                    // Analytics tracking Step 2 Error
                    _self.trackRegistrationStep('customer:registerSecond', true);

                    _self.showPhoneError('');
                }
            })
            .always(function () {
                _self.isSubmitting = false;
            });
    }

    showPhoneError (msg) {
        $(SELECTORS.phoneError)
            .html(msg)
            .addClass('login-form-error-block')
            .removeClass('success-block hide hidden');
    }

    // ─── Step 3: Register ────────────────────────────────────────────────────

    transitionToRegister (herokuData, hideDob) {
        this.toggleVisible(SELECTORS.stepPhone, false);
        this.toggleVisible(SELECTORS.stepRegister, true);

        if (this.isModal()) {
            var $logoTitle = $('.cc-unified-logo-title-noloy');
            var registerTitle = $logoTitle.data('title-register-noloy');
            if (registerTitle) {
                $logoTitle.text(registerTitle);
            }
        }

        if (hideDob) {
            $(SELECTORS.dobWrapper).closest('.cc-registrationModal__finalFieldWrp').addClass('hide');
            $(SELECTORS.dobWrapper).addClass('hidden');
            $(SELECTORS.regDob).removeAttr('required').val('').prop('required', false);
        } else {
            $(SELECTORS.dobWrapper).closest('.cc-registrationModal__finalFieldWrp').removeClass('hide');
            $(SELECTORS.dobWrapper).removeClass('hidden');
        }

        // Copy prefix and phone values to hidden fields of Step 3 for final SFCC submission
        $('.js-hidden-prefix').val($(SELECTORS.phonePrefix).val().trim());
        $('.js-hidden-phone').val($(SELECTORS.phoneInput).val().trim());

        $(SELECTORS.regEmailRecap).text($(SELECTORS.emailInput).val().trim());
        $(SELECTORS.regPhoneRecap).text(
            $(SELECTORS.phonePrefix).val().trim() + $(SELECTORS.phoneInput).val().trim()
        );

        var isSocial = $('#isSocialRegistration').val() === 'true';
        if (isSocial) {
            $('.js-registrationModal__password-row').addClass('hidden');
            $('#registration-form-password, #registration-form-password-confirm').removeAttr('required').val('');
        } else {
            $('.js-registrationModal__password-row').removeClass('hidden');
            $('#registration-form-password, #registration-form-password-confirm').attr('required', 'required');
        }

        // Dynamically initialize fdatepicker to prevent Tingle.js modal cloning from breaking it
        var $dobTrigger = $('.js-step-register .datepickerTriggerElement');
        var formatPattern = $dobTrigger.data('date-format-pattern') || 'dd-mm-yyyy';

        if (typeof $dobTrigger.fdatepicker === 'function') {
            $dobTrigger.fdatepicker({
                format: formatPattern,
                disableDblClickSelection: true,
                leftArrow: '<<',
                rightArrow: '>>',
                closeIcon: 'X',
                closeButton: false
            }).on('changeDate', function (ev) {
                var date = new Date(ev.date.valueOf() + ev.date.getTimezoneOffset() * 60000);
                var day = ('0' + date.getDate()).slice(-2);
                var month = ('0' + (date.getMonth() + 1)).slice(-2);
                var year = date.getFullYear();

                var datestring = day + '-' + month + '-' + year;
                if (formatPattern === 'mm-dd-yyyy') {
                    datestring = month + '-' + day + '-' + year;
                } else if (formatPattern === 'yyyy年mm月dd日') {
                    datestring = year + '年' + month + '月' + day + '日';
                }

                $('#dpReg').val(datestring);
                $dobTrigger.data('date', datestring);
                $('#dpReg').trigger('input');
            });
        }

        // Trigger datepicker open on calendar icon click
        $('.js-open-datepicker').on('click', function () {
            $('#dpReg').focus();
        });

        if (herokuData) {
            this.prefillRegisterForm(herokuData);
        } else {
            this.updateButtonStatus();
        }
    }
    prefillRegisterForm (data) {
        if (data.firstName) $(SELECTORS.regFirstName).val(data.firstName);
        if (data.lastName) $(SELECTORS.regLastName).val(data.lastName);
        if (data.birthDate) {
            var parts = null;
            if (data.birthDate.indexOf('-') > -1) {
                parts = data.birthDate.split('T')[0].split('-');
            } else if (data.birthDate.indexOf('/') > -1) {
                parts = data.birthDate.split('/');
            }
            if (parts && parts.length === 3) {
                var day, month, year;
                if (parts[0].length === 4) {
                    year = parts[0];
                    month = parts[1];
                    day = parts[2];
                } else {
                    day = parts[0];
                    month = parts[1];
                    year = parts[2];
                }
                day = day.length === 1 ? '0' + day : day;
                month = month.length === 1 ? '0' + month : month;

                var dobVal = day + '-' + month + '-' + year;
                $(SELECTORS.regDob).val(dobVal);
            }
        }
        if (data.gender) {
            $(SELECTORS.regGender).val(mapGender(data.gender));
        }
        if (data.directMarketingAgreement !== null && data.directMarketingAgreement !== undefined) {
            var marketingChecked = data.directMarketingAgreement === true;
            $('#add-to-email-list-yes').prop('checked', marketingChecked);
            $('#add-to-email-list-no').prop('checked', !marketingChecked);
            $('.js-add-to-email-toggle').prop('checked', marketingChecked).trigger('change');
        }
        if (data.profilingAgreement !== null && data.profilingAgreement !== undefined) {
            var profilingChecked = data.profilingAgreement === true;
            $('#add-to-personalized-news-list-yes').prop('checked', profilingChecked);
            $('#add-to-personalized-news-list-no').prop('checked', !profilingChecked);
            $('.js-add-to-personalized-toggle').prop('checked', profilingChecked).trigger('change');
        }
        this.updateButtonStatus();
    }

    isValidPassword (password) {
        if (!password || password.length < 8) return false;
        var hasUppercase = /[A-Z]/.test(password);
        var hasLowercase = /[a-z]/.test(password);
        var hasNumber = /\d/.test(password);
        var hasSpecial = /[^A-Za-z0-9]/.test(password);

        return hasUppercase && hasLowercase && hasNumber && hasSpecial;
    }

    updateButtonStatus () {
        var $activeStep = $(SELECTORS.stepRegister).filter(':visible').first();
        if (!$activeStep.length) {
            $activeStep = $(SELECTORS.stepRegister);
        }
        var fname = $activeStep.find(SELECTORS.regFirstName).val() || '';
        var lname = $activeStep.find(SELECTORS.regLastName).val() || '';
        var password = $activeStep.find('#registration-form-password').val() || '';
        var confirmPassword = $activeStep.find('#registration-form-password-confirm').val() || '';

        var isSocial = $('#isSocialRegistration').val() === 'true';

        var allFieldsFilled;
        if (isSocial) {
            allFieldsFilled = fname.trim() !== '' && lname.trim() !== '';
        } else {
            allFieldsFilled = fname.trim() !== '' && lname.trim() !== '' && password.trim() !== '' && confirmPassword.trim() !== '';
        }

        if (!isSocial && password.length && confirmPassword.length) {
            var validPassword = this.isValidPassword(password);
            var passwordsMatch = password === confirmPassword;
            allFieldsFilled = allFieldsFilled && validPassword && passwordsMatch;
        }

        if (allFieldsFilled) {
            $('.register-form-button').prop('disabled', false);
        } else {
            $('.register-form-button').prop('disabled', true);
        }

        this.updatePasswordTip(password);
    }

    updatePasswordTip (password) {
        var $tip = $('.js-passwordTip--registration-modal');
        if ($tip.length) {
            $tip.find('.minimum-length').toggleClass('cc-password-validated-req', password.length >= 8);
            $tip.find('.capital-letter').toggleClass('cc-password-validated-req', /[A-Z]/.test(password));
            $tip.find('.special-letter').toggleClass('cc-password-validated-req', /[^A-Za-z0-9]/.test(password));
            $tip.find('.number').toggleClass('cc-password-validated-req', /\d/.test(password));
        }
    }

    // ─── Date of Birth ───────────────────────────────────────────────────────

    assembleDob () {
        var day = $(SELECTORS.dobDay).val().trim();
        var month = $(SELECTORS.dobMonth).val().trim();
        var year = $(SELECTORS.dobYear).val().trim();
        var format = $(SELECTORS.dobWrapper).data('date-format-pattern') || 'dd-mm-yyyy';
        var assembled = '';

        if (day && month && year) {
            if (format === 'mm-dd-yyyy') {
                assembled = month + '-' + day + '-' + year;
            } else if (format === 'yyyy年mm月dd日') {
                assembled = year + '年' + month + '月' + day + '日';
            } else {
                assembled = day + '-' + month + '-' + year;
            }
        }

        $(SELECTORS.regDob).val(assembled);
    }

    validateDob () {
        var $dobWrapper = $(SELECTORS.dobWrapper);
        if (!$dobWrapper.length) return true;

        var day = $(SELECTORS.dobDay).val().trim();
        var month = $(SELECTORS.dobMonth).val().trim();
        var year = $(SELECTORS.dobYear).val().trim();

        if (!day || !month || !year) {
            $(SELECTORS.dobError).text($(SELECTORS.regDob).data('parsley-required-message') || '').show();
            return false;
        }

        $(SELECTORS.dobError).text('').hide();
        return true;
    }

    // ─── Navigation ──────────────────────────────────────────────────────────

    handleStepBack (e) {
        e.preventDefault();

        var $passwordWrapper = $(SELECTORS.passwordWrapper);
        if ($passwordWrapper.is(':visible')) {
            var $emailInput = $(SELECTORS.emailInput);
            $emailInput.removeAttr('readonly');

            this.toggleVisible(SELECTORS.emailRecap, false);
            this.toggleVisible(SELECTORS.emailFormGroup, true);

            $(SELECTORS.loginFormError).addClass('hidden').empty();

            this.toggleVisible(SELECTORS.loginDescription, true);
            this.toggleVisible(SELECTORS.loginSubtitle, false);
            this.toggleVisible(SELECTORS.passwordWrapper, false);
            this.toggleVisible(SELECTORS.resetPasswordWrapper, false);
            this.toggleVisible(SELECTORS.rememberMeWrapper, false);
            this.toggleVisible(SELECTORS.btnLoginSubmit, false);
            this.toggleVisible(SELECTORS.btnEmailNext, true);
            this.toggleVisible(SELECTORS.socialSection, true);
            this.toggleVisible(SELECTORS.btnStepBack, false);

            $(SELECTORS.passwordInput).val('');

            var $titleNoLoy = $('.cc-unified-logo-title-noloy, .cc-unified-description-title-noloy');
            $titleNoLoy.each(function () {
                var originalTitle = $(this).data('title-noloy');
                if (originalTitle) {
                    $(this).text(originalTitle);
                }
            });

            $emailInput.focus();
            return;
        }

        var $stepPhone = $(SELECTORS.stepPhone);
        if ($stepPhone.is(':visible')) {
            this.resetPhoneStep();
            this.toggleVisible(SELECTORS.stepPhone, false);
            this.toggleVisible(SELECTORS.stepEmail, true);
            this.toggleVisible(SELECTORS.btnStepBack, false);

            var $logoTitle = $('.cc-unified-logo-title-noloy');
            var originalTitle = $logoTitle.data('title-noloy');
            if (originalTitle) {
                $logoTitle.text(originalTitle);
            }

            $(SELECTORS.emailInput).focus();
            if (!this.isModal()) {
                $('body').removeClass('cc-registration-funnel-active');
            }
            return;
        }

        var $stepOtp = $(SELECTORS.stepOtp);
        if ($stepOtp.length && $stepOtp.is(':visible')) {
            this.toggleVisible(SELECTORS.stepOtp, false);
            this.toggleVisible(SELECTORS.stepRegister, true);
            return;
        }

        var $stepRegister = $(SELECTORS.stepRegister);
        if ($stepRegister.length && $stepRegister.is(':visible')) {
            this.toggleVisible(SELECTORS.stepRegister, false);
            this.toggleVisible(SELECTORS.stepPhone, true);
            $(SELECTORS.phoneInput).focus();
        }
    }

    // ─── Reset helpers ───────────────────────────────────────────────────────

    resetPhoneStep () {
        this.clearField(SELECTORS.phoneInput, null);
        $(SELECTORS.phoneStepEmailRecap).text('');
        $(SELECTORS.phoneNextBtn).prop('disabled', true);
        $(SELECTORS.phoneError).empty().removeClass('login-form-error-block success-block hide').addClass('hidden');
    }

    resetWizard () {
        this.clearField(SELECTORS.emailInput, SELECTORS.emailError, { removeReadonly: true });
        this.clearField(SELECTORS.passwordInput, SELECTORS.passwordError);
        this.resetPhoneStep();

        $(SELECTORS.emailRecapValue).text('');
        this.toggleVisible(SELECTORS.emailRecap, false);
        this.toggleVisible(SELECTORS.emailFormGroup, true);

        $(SELECTORS.loginFormError).addClass('hidden').empty();

        var $logoTitle = $('.cc-unified-logo-title-noloy');
        var originalTitle = $logoTitle.data('title-noloy');
        if (originalTitle) {
            $logoTitle.text(originalTitle);
        }

        this.toggleVisible(SELECTORS.loginDescription, true);
        this.toggleVisible(SELECTORS.loginSubtitle, false);
        this.toggleVisible(SELECTORS.passwordWrapper, false);
        this.toggleVisible(SELECTORS.resetPasswordWrapper, false);
        this.toggleVisible(SELECTORS.rememberMeWrapper, false);
        this.toggleVisible(SELECTORS.btnLoginSubmit, false);
        this.toggleVisible(SELECTORS.btnEmailNext, true);
        this.toggleVisible(SELECTORS.socialSection, true);
        this.toggleVisible(SELECTORS.btnStepBack, false);

        $(SELECTORS.allSteps).addClass('hidden').removeClass('active');
        this.toggleVisible(SELECTORS.stepEmail, true);
    }

    // ─── Utilities ───────────────────────────────────────────────────────────

    toggleVisible (selector, visible) {
        var $el = $(selector);
        if (visible) {
            $el.removeClass('hidden').addClass('active');
        } else {
            $el.addClass('hidden').removeClass('active');
        }
    }

    clearField (inputSelector, errorSelector, options) {
        var opts = options || {};
        var $input = $(inputSelector);
        if ($input.length) {
            $input.val('').removeClass('parsley-error is-invalid');
            if (opts.removeReadonly) {
                $input.removeAttr('readonly').css('color', '');
            }
        }
        if (errorSelector) {
            var $error = $(errorSelector);
            if ($error.length) {
                $error.text('').hide();
            }
        }
    }

    showValidationError ($input, $errorEl, errorMsg) {
        $input.addClass('parsley-error');
        $errorEl.text(errorMsg).show();
    }

    handleRegisterSubmitClick (btn) {
        var form = $(btn).closest('form').get(0);
        if (this.isSubmitting || !form || typeof form.checkValidity !== 'function' || form.checkValidity()) {
            return;
        }

        // Analytics tracking Step 3 Error (client-side validation)
        this.trackRegisterThird(true);
    }

    getPrivacyNews () {
        return $(SELECTORS.stepRegister).find('.js-add-to-email-toggle:checked, #add-to-email-list-yes:checked').length > 0
            || $('.js-add-to-email-toggle:checked, #add-to-email-list-yes:checked, .newspromotion:checked').length > 0;
    }

    getPrivacyCustomNews () {
        return $(SELECTORS.stepRegister).find('.js-add-to-personalized-toggle:checked, #add-to-personalized-news-list-yes:checked').length > 0
            || $('.js-add-to-personalized-toggle:checked, #add-to-personalized-news-list-yes:checked, .personalizednews:checked').length > 0;
    }

    trackRegisterThird (isError, isSocial) {
        this.trackRegistrationStep('customer:registerThird', isError, {
            'typeOfAccount': this.getTypeOfAccount(),
            'rememberMe': $('#rememberMeRegister, #registration-form-remember-me').prop('checked'),
            'privacyNews': this.getPrivacyNews(),
            'privacyCustomNews': this.getPrivacyCustomNews(),
            // Landing page: step 4 fires on the thank you page load (social has its own thank you events)
            'thankYouPageOnLoad': !isError && !isSocial && !this.isModal()
        });
    }

    // ─── Step 4: OTP Waiting Room ────────────────────────────────────────────

    handleRegisterSubmit (e) {
        var _self = this;
        var $form = $(SELECTORS.registerForm);

        if (this.isSubmitting) return;
        this.isSubmitting = true;
        $.spinner().start();

        // Clear previous form errors
        $('.login-form-error').html('').hide();
        $('.login-form-error-generic').addClass('hidden');

        var isModal = this.isModal();
        var dataForm = $form.serialize();
        if (isModal) {
            dataForm += '&isModalFlow=true';
        }

        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            dataType: 'json',
            data: dataForm,
            success: function (data) {
                $.spinner().stop();
                if (data.success) {
                    var isSocial = $('#isSocialRegistration').val() === 'true';

                    // Analytics tracking Step 3 Success
                    _self.trackRegisterThird(false, isSocial);

                    if (isSocial) {
                        if (data.redirectUrl) {
                            window.location.href = data.redirectUrl;
                        }
                    } else if (isModal) {
                        // Transition to OTP verification step instead of direct redirection
                        _self.transitionToOtp();

                        // Analytics tracking Step 4
                        $('body').trigger('customer:registerThankYouPage', {
                            'typeOfAccount': _self.getTypeOfAccount(),
                            'regFlowPosition': _self.getRegFlowPosition()
                        });
                    } else if (data.redirectUrl) {
                        // Standalone page: same double opt-in confirmation email/page as the as-is flow
                        window.location.href = data.redirectUrl;
                    }
                } else {
                    // Analytics tracking Step 3 Error
                    _self.trackRegisterThird(true);

                    var errMsg = data.error
                        ? (Array.isArray(data.error) ? data.error.join('<br/>') : data.error)
                        : (data.message || 'Error during registration.');

                    $('.login-form-error').html(errMsg).show();
                    $('.login-form-error-generic').removeClass('hidden').show();

                    // Per-field server errors (e.g. birth date too old/in the future/underage)
                    // are keyed by html "name", same convention as FormHelpers.init uses for the
                    // legacy flow. Our fields use .form-error (not .invalid-feedback), so we
                    // show them ourselves instead of relying on that shared helper.
                    if (data.fields) {
                        Object.keys(data.fields).forEach(function (key) {
                            if (!data.fields[key]) return;
                            var $field = $form.find('[name="' + key + '"]');
                            if (!$field.length) return;
                            $field.closest('.form-fields-item').find('.form-error')
                                .first()
                                .text(data.fields[key])
                                .show();
                        });
                    }
                }
            },
            error: function () {
                $.spinner().stop();
                $('.login-form-error').html('A technical error occurred. Please try again.').show();
                $('.login-form-error-generic').removeClass('hidden').show();

                // Analytics tracking Step 3 Error
                _self.trackRegisterThird(true);
            }
        }).always(function () {
            _self.isSubmitting = false;
        });
    }

    transitionToOtp () {
        this.toggleVisible(SELECTORS.stepRegister, false);
        this.toggleVisible(SELECTORS.stepOtp, true);

        // Reset submission flag to allow a new OTP auto-submit cycle
        this.isSubmitting = false;
        this.otpManualMode = false;

        var $container = $(SELECTORS.stepOtp);

        // Reset OTP input fields
        $container.find(SELECTORS.otpInput).val('');
        $container.find(SELECTORS.otpConfirmBtn).addClass('hidden').prop('disabled', true);

        // Reset visibility of localized ISML errors
        $container.find(SELECTORS.wrongOtpError).addClass('hidden');
        $container.find(SELECTORS.expiredOtpError).addClass('hidden');

        // Focus on the first OTP input field
        $container.find(SELECTORS.otpInput).first().focus();
    }

    // Enables the submit button once all boxes are filled, and auto-submits
    // unless we're in manual-retry mode (see submitOtp's error branch).
    evaluateOtpFill ($container) {
        var $inputs = $container.find(SELECTORS.otpInput);
        var isFilled = $inputs.get().every(function (inp) {
            return $(inp).val().trim() !== '';
        });

        $container.find(SELECTORS.otpConfirmBtn).prop('disabled', !isFilled);

        if (isFilled && !this.otpManualMode) {
            this.submitOtp($container);
        }
    }

    handleOtpKeyup (e, input) {
        var $container = $(input).closest('.js-step-otp, .registration-modal-waiting');
        var $inputs = $container.find(SELECTORS.otpInput);
        var currentIndex = $inputs.index(input);

        // Hide wrong/expired OTP validation errors as soon as the user starts correcting/rewriting the code
        $container.find(SELECTORS.wrongOtpError).addClass('hidden');
        $container.find(SELECTORS.expiredOtpError).addClass('hidden');

        // type="number" does not enforce the maxlength="1" attribute, so
        // digits typed fast (or a single-box paste) can exceed one character.
        var sanitized = $(input).val().replace(/[^0-9]/g, '').slice(-1);
        if (sanitized !== $(input).val()) {
            $(input).val(sanitized);
        }

        // If user presses Backspace and input is empty, move focus to the previous input
        if (e.keyCode === 8 && sanitized.length === 0) {
            var $prev = $inputs.eq(currentIndex - 1);
            if ($prev.length) {
                $prev.focus();
            }
        // If a digit is entered, move focus to the next input
        } else if (sanitized.length > 0) {
            var $next = $inputs.eq(currentIndex + 1);
            if ($next.length) {
                $next.focus();
            }
        }

        this.evaluateOtpFill($container);
    }

    // Distributes a pasted OTP code (e.g. copied from an SMS) one digit per box,
    // instead of dumping the whole string into whichever box received the paste.
    handleOtpPaste (e, input) {
        var clipboardData = (e.originalEvent || e).clipboardData || window.clipboardData;
        if (!clipboardData) return;

        var pasted = clipboardData.getData('text').replace(/[^0-9]/g, '');
        if (!pasted.length) return;

        e.preventDefault();

        var $container = $(input).closest('.js-step-otp, .registration-modal-waiting');
        var $inputs = $container.find(SELECTORS.otpInput);
        var digits = pasted.slice(0, $inputs.length).split('');

        // Hide wrong/expired OTP validation errors when a new code is pasted
        $container.find(SELECTORS.wrongOtpError).addClass('hidden');
        $container.find(SELECTORS.expiredOtpError).addClass('hidden');

        $inputs.each(function (index) {
            $(this).val(digits[index] || '');
        });

        var $lastFilled = $inputs.eq(Math.min(digits.length, $inputs.length) - 1);
        if ($lastFilled.length) {
            $lastFilled.focus();
        }

        this.evaluateOtpFill($container);
    }

    handleOtpConfirm (e) {
        e.preventDefault();
        var $container = $(e.currentTarget).closest('.js-step-otp, .registration-modal-waiting');
        this.submitOtp($container);
    }

    submitOtp ($container) {
        var _self = this;
        if (this.isSubmitting) return;

        var $confirmBtn = $container.find(SELECTORS.otpConfirmBtn);
        var url = $confirmBtn.data('registration-otp-url');
        if (!url) {
            console.error('Unified Registration: Missing OTP Confirmation URL.');
            return;
        }

        this.isSubmitting = true;
        $.spinner().start();

        // Reset visibility of localized error messages before verification
        $container.find(SELECTORS.wrongOtpError).addClass('hidden');
        $container.find(SELECTORS.expiredOtpError).addClass('hidden');

        var email = $(SELECTORS.emailInput).val().trim();
        var otpCodeInput = '';
        $container.find(SELECTORS.otpInput).each(function () {
            otpCodeInput += $(this).val();
        });

        $.ajax({
            url: url,
            type: 'GET',
            data: {
                email: email,
                otpCodeInput: otpCodeInput
            },
            success: function (data) {
                $.spinner().stop();
                if (data.success) {
                    // Analytics tracking Step 4 Double Opt-in Success
                    _self.trackConfirmOptin(false);

                    // Log the user in after successful registration and reload the page
                    _self.loginAfterRegistration();
                } else {
                    // Analytics tracking Step 4 Double Opt-in Error
                    _self.trackConfirmOptin(true);

                    // Auto-submit failed: stop auto-submitting and let the customer
                    // fix the code and confirm manually via the now-visible button.
                    _self.otpManualMode = true;
                    $confirmBtn.removeClass('hidden').prop('disabled', false);

                    if (data.expiredOtp) {
                        $container.find(SELECTORS.expiredOtpError).removeClass('hidden');
                        $container.find(SELECTORS.wrongOtpError).addClass('hidden');
                    } else {
                        $container.find(SELECTORS.wrongOtpError).removeClass('hidden');
                        $container.find(SELECTORS.expiredOtpError).addClass('hidden');
                    }
                }
            },
            error: function () {
                $.spinner().stop();
                _self.otpManualMode = true;
                $confirmBtn.removeClass('hidden').prop('disabled', false);
                $container.find(SELECTORS.wrongOtpError).removeClass('hidden');
                $container.find(SELECTORS.expiredOtpError).addClass('hidden');

                // Analytics tracking Step 4 Double Opt-in Error
                _self.trackConfirmOptin(true);
            }
        }).always(function () {
            _self.isSubmitting = false;
        });
    }

    loginAfterRegistration () {
        var url = $('form.login').attr('action');
        var email = $(SELECTORS.emailInput).val().trim();
        var password = $('#registration-form-password').val();
        var csrfToken = $('input[name="csrf_token"]').val();
        var rememberMeChecked = $('#registration-form-remember-me').prop('checked') ? 'on' : null;
        var formData = {
            loginEmail: email,
            loginPassword: password,
            csrf_token: csrfToken,
            loginRememberMe: rememberMeChecked
        };
        $.spinner().start();

        $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            data: formData,
            success: function (data) {
                $.spinner().stop();
                if (data.success) {
                    $('form.login').trigger('login:success', data);
                    location.reload();
                } else {
                    // Fallback to Home page if automatic login fails for some reason
                    window.location.href = window.location.origin;
                }
            },
            error: function () {
                $.spinner().stop();
                window.location.href = window.location.origin;
            }
        });
    }

    unifiedLogout () {
        if (window.Urls && window.Urls.logout) {
            window.location.href = window.Urls.logout;
        }
    }

    unifiedCloseModalReloadOrLogout () {
        var _self = this;
        var isUserLogged = $('#registrationLoyaltyModal').attr('data-unified-user-logged') === 'true';
        var isCountryExcluded = $('#isCountryExcludedFromImplicitLoyalty').val() === 'true';

        if (this.currentRegistrationOrDeleteStage === 'registrationComplete' || (isUserLogged && isCountryExcluded)) {
            location.reload();
        } else if (isUserLogged) {
            _self.unifiedLogout();
        }
    }

    unifiedLoyaltybuttonBackInit () {
        var _self = this;

        if (this.isModal()) {
            $(SELECTORS.btnStepBack).on('click', function (e) {
                var $registrationModal = $('.registrationModal-box');
                var currentStep = $registrationModal.attr('data-registration-modal-stage');
                switch (currentStep) {
                case 'content':
                    $('.js-close-unified-registration-or-delete-modal').trigger('click');
                    break;
                case 'registration' :
                    $registrationModal.attr('data-registration-modal-stage', 'content');
                    var isCountryExcluded = $('#isCountryExcludedFromImplicitLoyalty').val() === 'true';
                    if (isCountryExcluded) {
                        $('.loyalty-registration-modal-content').removeClass('hidden');
                        $('.loyalty-registration-modal-registration').addClass('hidden');
                    } else {
                        $('.js-unified-loyalty-registration-or-delete-container').removeClass('hidden');
                        $('.js-unified-loyalty-registration-container').addClass('hidden');
                    }
                    break;
                default:
                    break;
                }
            });
        } else {
            history.replaceState({ stage: 'content' }, '');

            $(window).off('popstate.unifiedLoyalty').on('popstate.unifiedLoyalty', (e) => {
                if (_self.currentRegistrationOrDeleteStage === 'registrationComplete' || _self.currentRegistrationOrDeleteStage === 'deleteComplete') {
                    location.reload();
                    return;
                }

                var state = e.originalEvent.state;
                var $registrationModal = $('.registrationModal-box');

                if (state && state.stage) {
                    $registrationModal.attr('data-registration-modal-stage', state.stage);

                    if (state.stage === 'content') {
                        $('.js-unified-loyalty-registration-or-delete-container').removeClass('hidden');
                        $('.js-unified-loyalty-registration-container').addClass('hidden');
                    } else if (state.stage === 'registration') {
                        $('.js-unified-loyalty-registration-or-delete-container').addClass('hidden');
                        $('.js-unified-loyalty-registration-container').removeClass('hidden');
                    }
                }
            });
        }
    }

    unifiedModalLoyaltyRegistrationInit () {
        var _self = this;
        $('.js-unified-modal-loyalty-registration').off('click').on('click', function (e) {
            e.preventDefault();
            if (_self.isLoyaltyModalOpening) {
                return;
            }
            _self.isLoyaltyModalOpening = true;
            let url = $('#registrationLoyaltyModalURL').data('url');
            if (!url) {
                console.error('Missing URL for AJAX call');
                _self.isLoyaltyModalOpening = false;
                return;
            }
            $.ajax(url).then(data => {
                _self.isLoyaltyModalOpening = false;
                if (!_self.isModal()) {
                    var innerContent = $(data).find('#registrationModal-box');
                    $('.js-unified-flow-container').html(innerContent);
                    if ($('.js-thankYouPage').length) {
                        $('.js-thankYouPage').addClass('hidden');
                        $('.js-categoryThanks').addClass('hidden');
                    }
                } else {
                    $('.js-unified-flow-container').html(data);
                }

                RegistrationHelper.datePickerInit();

                $('.js-unified-loyalty-registration-container .datepickerTriggerElement').on('changeDate', function () {
                    _self.updateLoyaltyCtaStatus();
                });

                Customer.accountRegisterForm();
                RegistrationHelper.proceedToRegistrationLoyaltyInit();
                _self.unifiedLoyaltybuttonBackInit();
                RegistrationHelper.moveToNextStep('content');
            }).catch(() => {
                _self.isLoyaltyModalOpening = false;
            });
        });
    }

    proceedToUnifiedRegistrationLoyaltyInit (e) {
        if (e) {
            e.preventDefault();
        }
        if (!this.isModal()) {
            history.pushState({ stage: 'registration' }, '');
        }

        $('.registrationModal-box').attr('data-registration-modal-stage', 'registration');
        $('.js-unified-loyalty-registration-or-delete-container').addClass('hidden');
        $('.js-unified-loyalty-registration-container').removeClass('hidden');

        this.updateLoyaltyCtaStatus();
    }

    updateLoyaltyCtaStatus () {
        var dobVal = $('.js-unified-loyalty-registration-container #dpReg').val() || '';
        var isValid = dobVal.trim() !== '';

        var $submitBtn = $('.js-unified-loyalty-registration-container button[type="submit"]');
        if ($submitBtn.length) {
            if (isValid) {
                $submitBtn.prop('disabled', false).removeClass('disabledForm');
                $('.js-unified-loyalty-registration-container #dpReg').removeClass('is-invalid parsley-error');
            } else {
                $submitBtn.prop('disabled', true).addClass('disabledForm');
            }
        }
    }

    handleLoyaltyRegisterSubmit (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var _self = this;
        var $form = $(e.currentTarget);
        var url = $form.attr('action');

        if (this.isSubmitting) return;
        this.isSubmitting = true;
        $.spinner().start();

        $form.find('.js-unified-loyalty-registration-container #dpReg').removeClass('is-invalid parsley-error');

        var dataForm = $form.serialize();

        $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            data: dataForm,
            success: function (data) {
                $.spinner().stop();
                if (data.success) {
                    // Analytics tracking Loyalty Card Subscription (EventID: 13)
                    // Already registered user: only the digital loyalty card is created
                    $('body').trigger('customer:registerLoyalty', 'only_loyalty');

                    $('.js-unified-loyalty-registration-container').addClass('hidden');
                    $('.js-unified-loyalty-registration-success').removeClass('hidden');
                    if (_self.isModal()) {
                        $(SELECTORS.btnStepBack).addClass('cc-unified-last-hide-arrow');
                    }
                    _self.currentRegistrationOrDeleteStage = 'registrationComplete';
                } else {
                    var errMsg = data.error;
                    $form.find('.login-form-error').html(errMsg).removeClass('hidden');
                    $form.find('.js-unified-loyalty-registration-container #dpReg').addClass('is-invalid parsley-error');
                }
            },
            error: function (data) {
                $.spinner().stop();
                var errMsg = data.error;
                $form.find('.login-form-error').html(errMsg).removeClass('hidden');
                $form.find('.js-unified-loyalty-registration-container #dpReg').addClass('is-invalid parsley-error');
            }
        }).always(function () {
            _self.isSubmitting = false;
        });
    }

    handleUnifiedAccountDelete (e) {
        e.preventDefault();

        var $deleteModalSource = $('#accountDeleteConfirmModal');
        if (!$deleteModalSource.length) {
            console.error('Unified Deletion: Missing #accountDeleteConfirmModal in DOM.');
            return;
        }

        var htmlContent = $deleteModalSource.clone().html();

        var modal = newModalFromString(htmlContent, false, ['account-delete-tingle', 'cc-unified-account-delete-modal', 'js-unified-account-delete-modal']);
        modal.open();

        $(modal.modalBox).on('click', '#accountDeleteConfirmModalNo, #accountDeleteCloseErrorModal', function (ev) {
            ev.preventDefault();
            modal.close();
            modal.destroy();
        });

        $(modal.modalBox).on('click', '.close, .btn-close, #accountDeleteCloseSuccessModal', function (ev) {
            ev.preventDefault();
            if (window.redirectToHomepageInsteadClosing) {
                var redirectUrl = $(modal.modalBox).find('#accountDeleteHiddenHomeLink').attr('href') || '/';
                window.location.replace(redirectUrl);
                window.redirectToHomepageInsteadClosing = undefined;
            } else {
                modal.close();
                modal.destroy();
            }
        });

        $(modal.modalBox).on('click', '#accountDeleteConfirmModalYes', function (ev) {
            ev.preventDefault();
            var $btn = $(this);
            if ($btn.prop('disabled')) {
                return;
            }
            $btn.prop('disabled', true).addClass('disabled');

            var url = $deleteModalSource.data('account-delete-url');

            $.spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (data) {
                    if (data.error) {
                        $btn.prop('disabled', false).removeClass('disabled');
                        onErrorHandler();
                    } else {
                        window.redirectToHomepageInsteadClosing = true;
                        $.spinner().stop();
                        location.reload();
                    }
                },
                error: function () {
                    $btn.prop('disabled', false).removeClass('disabled');
                    onErrorHandler();
                }
            });

            function onErrorHandler () {
                $('.js-unified-account-delete-modal #accountCancellationModalStep1').addClass('hidden');
                $('.js-unified-account-delete-modal #accountCancellationModalError').removeClass('hidden');
                $.spinner().stop();
            }
        });
    }

    initCustomerServiceFlow () {
        var email = $('#scEmail').val() || $(SELECTORS.emailInput).val() || '';
        var phone = $('#scPhone').val() || '';
        var prefix = $('#scPhonePrefix').val() || '';
        var scFlow = $('#scFlow').val() || '';
        var hiddenPhonePlaceholder = $('#hiddenPhonePlaceholder').val() || '';
        var warnMsg = $('#scWarn').val() || '';

        var targetStep = 'email';
        if (scFlow === '1') {
            targetStep = 'phone';
        } else if (scFlow === '2') {
            targetStep = 'register';
        }

        this.prefillAndTransition({
            email: email,
            phone: phone,
            prefix: prefix,
            hiddenPhonePlaceholder: hiddenPhonePlaceholder,
            warnMsg: warnMsg,
            targetStep: targetStep
        });
    }

    initOrderConfirmationFlow () {
        var email = $('#ocEmail').val() || '';
        var phone = $('#ocPhone').val() || '';
        var prefix = $('#ocPhonePrefix').val() || '';
        var firstName = $('#ocFirstName').val() || '';
        var lastName = $('#ocLastName').val() || '';

        this.prefillAndTransition({
            email: email,
            phone: phone,
            prefix: prefix,
            firstName: firstName,
            lastName: lastName,
            targetStep: 'email'
        });
    }

    setPhonePrefix (prefix) {
        if (!prefix) {
            return;
        }
        var prefixStr = String(prefix).trim();
        var normalizedPrefix = prefixStr.indexOf('+') === 0 ? prefixStr : ('+' + prefixStr);
        $(SELECTORS.phonePrefix).val(normalizedPrefix).trigger('change');
    }

    prefillAndTransition (config) {
        // 1. Prefill inputs
        $(SELECTORS.emailInput).val(config.email).trigger('input');
        if (config.prefix) {
            this.setPhonePrefix(config.prefix);
        }

        // GDPR Compliance: If there's an obfuscated placeholder (***321), keep the visible input empty.
        // This ensures the browser only displays the masked asterischi as placeholder.
        if (config.targetStep === 'phone' && config.hiddenPhonePlaceholder) {
            $(SELECTORS.phoneInput).val('');
        } else if (config.phone) {
            $(SELECTORS.phoneInput).val(config.phone).trigger('input');
        }

        if (config.firstName) {
            $('#registration-form-fname').val(config.firstName).trigger('input');
        }
        if (config.lastName) {
            $('#registration-form-lname').val(config.lastName).trigger('input');
        }

        // 2. Prefill recaps
        $(SELECTORS.regEmailRecap).text(config.email);
        $(SELECTORS.phoneStepEmailRecap).text(config.email);
        var recapPhone = config.phone ? (config.prefix + config.phone) : (config.hiddenPhonePlaceholder ? (config.prefix + config.hiddenPhonePlaceholder) : config.prefix);
        $(SELECTORS.regPhoneRecap).text(recapPhone);
        $('.js-hidden-prefix').val(config.prefix);
        $('.js-hidden-phone').val(config.phone);

        // 3. Hide all steps first
        $(SELECTORS.allSteps).addClass('hidden').removeClass('active');

        // 4. Determine stage/step to transition to
        if (config.targetStep === 'phone') {
            this.transitionToPhone(config.hiddenPhonePlaceholder);
            if (config.warnMsg) {
                $(SELECTORS.herokuWarning).text(config.warnMsg).removeClass('hidden');
            }
        } else if (config.targetStep === 'register') {
            this.transitionToRegister();
        } else {
            // Default target step: email input (Email-First step)
            this.toggleVisible(SELECTORS.stepEmail, true);
            $(SELECTORS.emailInput).focus();
        }

        // 5. Add custom body class for layout styling on standalone page
        if (!this.isModal() && config.targetStep !== 'email') {
            $('body').addClass('cc-registration-funnel-active');
        }

        // 6. Recalculate button disable states
        this.updateButtonStatus();
    }
}

const unifiedRegistration = new UnifiedRegistration();
export default unifiedRegistration;
